var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBriefcase = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none",
  viewBox: "0 0 20 21"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M16.666 6.333H3.333c-.92 0-1.667.747-1.667 1.667v8.333c0 .92.746 1.667 1.667 1.667h13.333c.92 0 1.667-.746 1.667-1.667V8c0-.92-.746-1.667-1.667-1.667"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M13.333 18V4.667A1.667 1.667 0 0 0 11.666 3H8.333a1.667 1.667 0 0 0-1.667 1.667V18"
})));
export { SvgBriefcase as ReactComponent };